/** @typedef {{needsUpdate: boolean, isUnusable: boolean, cardType: string}} PaymentMethod */

/**
 * @param {PaymentMethod} paymentMethod
 * @returns {boolean}
 */
export function shouldShowNeedsUpdating(paymentMethod) {
  const needsUpdate = paymentMethod?.needsUpdate;
  const isUnusable = paymentMethod?.isUnusable;
  const paymentMethodIsBank =
    paymentMethod?.cardType?.toLowerCase() === "checking" ||
    paymentMethod?.cardType?.toLowerCase() === "savings";
  return isUnusable || (needsUpdate && paymentMethodIsBank);
}
